import { useSelector } from "react-redux";

import { Box, Grid, Typography } from "@mui/material";

const ProjectsData = ({ subheaderStyle, useMobileLayout }) => {
  const selectedRow = useSelector((state) => state.dataExplorer.selectedRow);
  return (
    <Grid
      item
      xs={12}
      md={useMobileLayout ? 12 : 8}
      sx={{ flexGrow: 1, overflowY: "auto" }}
    >
      <Box sx={{ width: "100%" }}>
        {selectedRow.row.description && (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography {...subheaderStyle}>
              About
              <Typography
                sx={{
                  color: "primary.contrastText",
                }}
              >
                {selectedRow.row.description}
              </Typography>
            </Typography>
          </Box>
        )}
        {selectedRow.row.basin && (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography {...subheaderStyle}>
              Basin
              <Typography
                sx={{
                  color: "primary.contrastText",
                }}
              >
                {selectedRow.row.basin.name}
              </Typography>
            </Typography>
          </Box>
        )}
      </Box>
    </Grid>
  );
};

export default ProjectsData;
